import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { RegistrationTypes } from "../../pages/Registration/Registration";
import styles from "./GetStartedSelect.module.css";

function NavButton(props) {
  const navigate = useNavigate();

  function handleClick(path) {
    navigate(path);
  }

  return (
    <Button
      className={`${props.type === props.current ? "disabledBtn" : props.class} ${styles.navButton}`}
      variant="primary"
      disabled={props.type === props.current ? true : false}
      onClick={() => handleClick(props.path)}
    >
      {props.title}
    </Button>
  );
}

class PaymentSelectButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      type: this.props.type,
    };
  }

  nextPath(path) {
    this.props.navigation?.navigate(path);
  }

  render() {
    return (
      <div className={styles.buttonGrid}>
          <NavButton
            type={RegistrationTypes.homeowner}
            current={this.props.type}
            path="/im-a-homeowner"
            title="I'M A HOMEOWNER"
            class="customBtnBlue"
          />
          <NavButton
            type={RegistrationTypes.renter}
            current={this.props.type}
            path="/im-a-renter"
            title="I'M A RENTER"
            class="customBtnRenter"
          />
          <NavButton
            type={RegistrationTypes.business}
            current={this.props.type}
            path="/im-a-business-owner"
            title="I'M A BUSINESS OWNER"
            class="customBtnBusiness"
          />
          <NavButton
            type={RegistrationTypes.other}
            current={this.props.type}
            path="/im-something-else"
            title="I'M HOSTING AN EVENT"
            class="customBtnElse"
          />
          <NavButton
            type={RegistrationTypes.nonprofit}
            current={this.props.type}
            path="/im-a-non-profit"
            title="I'M A NON-PROFIT"
            class="customBtnNonProfit"
          />
          <NavButton
            type={RegistrationTypes.indigenous}
            current={this.props.type}
            path="/im-indigenous"
            title="I'M INDIGENOUS"
            class="customBtnIndigenous"
          />
      </div>
    );
  }
}

export default PaymentSelectButton;